/**
 * @generated SignedSource<<4c0eff73f091ce7ede549fe72532cb84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PasswordResetPage_customPortal$data = {
  readonly contactEmail: string | null;
  readonly customColor: string | null;
  readonly faviconUrl: string | null;
  readonly footerImageUrl: string | null;
  readonly headerFontColor: string | null;
  readonly logoImageUrl: string | null;
  readonly pageTitle: string | null;
  readonly " $fragmentType": "PasswordResetPage_customPortal";
};
export type PasswordResetPage_customPortal$key = {
  readonly " $data"?: PasswordResetPage_customPortal$data;
  readonly " $fragmentSpreads": FragmentRefs<"PasswordResetPage_customPortal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PasswordResetPage_customPortal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "footerImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headerFontColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "faviconUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactEmail",
      "storageKey": null
    }
  ],
  "type": "CustomPortalNode",
  "abstractKey": null
};

(node as any).hash = "b44045d60ebd496576c81255be4b29a7";

export default node;
